import { render } from "./RemovePopup.vue?vue&type=template&id=2a25bdc9"
import script from "./RemovePopup.vue?vue&type=script&lang=js"
export * from "./RemovePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__